// extracted by mini-css-extract-plugin
export default {"card":"CardDescription_card__BUtF+"};